import React from 'react';
import { motion } from 'framer-motion';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function HomeHero() {
  const scrollToForm = () => {
    const formElement = document.getElementById('lead-form');
    if (formElement) {
      formElement.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative pt-12 pb-20 px-4 overflow-hidden" data-id="element-503">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-504">
        <img src="https://cdn.magicpatterns.com/uploads/a8suqKecAJZ7XFURrUfKj9/hero5.jpg" alt="NWBBA Dojang" className="w-full h-full object-cover" data-id="element-505" />
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#0f1f3d]/90 via-[#0f1f3d]/80 to-[#0f1f3d]/90" data-id="element-506"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-507">
        <motion.div initial="hidden" animate="visible" variants={fadeIn} className="space-y-6" data-id="element-508">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[#dc2626]/90 backdrop-blur-sm text-white text-sm font-bold tracking-wide uppercase mb-2 border-2 border-[#a3d977]/30" data-id="element-509">
            Northwest Black Belt Academy
          </span>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-black text-white leading-tight tracking-tight drop-shadow-2xl" data-id="element-510">
            Build Confidence, Discipline & Focus in Your Child
          </h1>
          <p className="text-lg sm:text-xl text-white/95 max-w-2xl mx-auto leading-relaxed drop-shadow-lg" data-id="element-511">
            Watch them transform in just 2 weeks. Give your child the tools to
            succeed in school and life through martial arts.
          </p>

          <div className="pt-4" data-id="element-512">
            <motion.a whileTap={{
            scale: 0.95
          }} onClick={scrollToForm} className="inline-block w-full sm:w-auto px-8 py-4 bg-[#dc2626] text-white text-lg font-bold rounded-lg shadow-lg shadow-red-900/50 hover:bg-red-700 transition-colors border-2 border-[#a3d977]/30 cursor-pointer" data-id="element-513">
              Start Your $29 Trial
            </motion.a>
            <p className="mt-3 text-sm text-white/90 drop-shadow-md" data-id="element-514">
              Limited time offer • No commitment required
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}